var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    throwIfNamespaceError: "false",
    viewBox: "0 0 172.28 172.28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#b);}.cls-2{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 89.64,
    x2: 89.64,
    y1: 463.14,
    y2: 290.86,
    gradientTransform: "matrix(1,0,0,-1,-3.5,463.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534bb1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#551bf9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 91.47,
    x2: 91.47,
    y1: 431.98,
    y2: 318.35,
    gradientTransform: "matrix(1,0,0,-1,-3.5,463.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.82,
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phantomlogo-freelogovectors.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 86.14,
    cy: 86.14,
    r: 86.14,
    fill: "url(#b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m147.8 87.19h-15.18a56.23 56.23 0 0 0-112.45-1.14c-0.63 31.43 29 58.74 60.52 58.74h4c27.82 0 65.11-21.7 70.94-48.15a7.89 7.89 0 0 0-7.83-9.45zm-94 1.38a7.55 7.55 0 0 1-15.1 0v-12.17a7.55 7.55 0 0 1 15.1 0zm26.22 0a7.55 7.55 0 0 1-15.1 0v-12.17a7.55 7.55 0 0 1 15.1 0z",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.1738d2fe59c03bf66bd7d9dbf6de0cb2.svg";
export { ForwardRef as ReactComponent };